import React, { Fragment, useState } from "react";
import Pagination from "../Std/Pagination";
import * as utilities from "../../utilities/utils";
import moment from "moment";
import DropdownComponent from "../../containers/Dropdown";
import history from "../../utilities/history";
import handSvg from "../../images/hand.svg";
import { PAGE_SIZE_DRP } from "../../App.config";
import SearchComponent from '../SearchComponent';

const AccomodationCaseStatustemplete = (props, context) => {
  const [state, forceUpdate] = useState(0);
  const [search, setSearch] = useState("");

  const addRow = (i) => {
    if (props.caseStatusDetails[i].otherData) {
      delete props.caseStatusDetails[i].otherData;
    } else {
      props.caseStatusDetails[i].otherData = {
        DateCaseOpened: props.caseStatusDetails[i].dateCaseOpened,
        PreviousHistory:
          props.caseStatusDetails[i].prevHistoryWithOncEmployment,
        CaseNumber: props.caseStatusDetails[i].caseMgmtID,
        CaseType: props.caseStatusDetails[i].caseType,
        CaseManager: props.caseStatusDetails[i].managedBy,
        NumberOfOpenDays: props.caseStatusDetails[i].daysLost,
        NumberOfOpenDaysBussiness: props.caseStatusDetails[i].daysLostBusiness,
        PhysicianStatement: props.caseStatusDetails[i].attendingPhyStatRecDate,
        FileStatusInfo: props.caseStatusDetails[i].fileStatusInformation,
        DateOfMedicalUpdates:
          props.caseStatusDetails[i].datesMedicalUpdatesReceived,
        DateEmployerStatementReceived:
          props.caseStatusDetails[i].dateEmployerStatementReceived,
        DateOfReductioninBenefits: props.caseStatusDetails[i].payReductionDate,
        DateCasebecame: props.caseStatusDetails[i].complexCaseDate,
        FirstDayAbsent: props.caseStatusDetails[i].firstDayAbsentFromWork,
        CaseStatus: props.caseStatusDetails[i].caseStatus,
        RestrictionsLimitations: props.caseStatusDetails[i].restrictions,
        ExpectedRTWDate: props.caseStatusDetails[i].xRTW,
        RTWDates: null,
        EIDates: props.caseStatusDetails[i].eiDates,
        STDExpiryDate: props.caseStatusDetails[i].STDExpiryDate,
        payReductionDate: props.caseStatusDetails[i].payReductionDate,
        DateClosed: null,
        LastUpdate: props.caseStatusDetails[i].lastUpdateFileStatusDate,
        NextAction: props.caseStatusDetails[i].nextAction,
      };
    }

    forceUpdate(state + 1);
  };

  const onDropDownChange = (event) => {
    let { name, value } = event;

    if (value.length) {
      props.onPageSizeChange(utilities.extractFirstValueOfArray(value));
    }
  };

  const onChange = (event) => {
    props.onChange({ name: event.target.name, value: event.target.value });
  };

  const onSearch = () => {
    if (search.trim()) {
      props.getSearchCaseStatus(search.trim());
    } else {
      props.getSearchCaseStatus(null);
    }
  };

  const handleChanges = (e) => {
    setSearch(e.target.value);
  }
  return (
    <>
      <div className="Inner-cell">
        <div className="Panel-cell">
          <div className="Card-panel">
            <div className="table-header">
              <div className="pagesize-dropdown">
                <DropdownComponent
                  name="pageSize"
                  options={PAGE_SIZE_DRP}
                  isMultiSelect={false}
                  option_key="pageSize"
                  option_display="pageSizeValue"
                  onChange={onDropDownChange}
                  values={[props.pageSize]}
                  simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                  selectAllText="Select All Options"
                  isSearchOption={false}
                />
              </div>
              <div class="row">
                <SearchComponent searchKeyword={search} handleChanges={handleChanges} context={props.context} onSearch={onSearch} />
              </div>
            </div>
            <div className="Table-list">
              <div className="Table-head">
                <div className="Table-cell">
                  <table className="table ">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>FDA/Date Case Opened</th>
                        <th>XRTW Date</th>
                        <th>Next Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.caseStatusDetails
                        ? props.caseStatusDetails.map((status, index) => (
                          <Fragment key={`status-${index}`}>
                            <tr
                              className="case-status-tb-row"
                              onClick={() => addRow(index)}
                            >
                              <td>
                                {status.firstName} {status.lastName}
                              </td>
                              <td
                                data-toggle="tooltip"
                                data-placement="top"
                                title={
                                  status.filename ? status.filename : null
                                }
                              >
                                {status.caseType ? status.caseType : "-"}
                              </td>
                              <td>
                                {status.dateCaseOpened
                                  ? utilities.formatDate(
                                    status.dateCaseOpened,
                                    "MMM DD YYYY"
                                  )
                                  : "-"}
                              </td>
                              <td>
                                {status.xRTW
                                  ? utilities.formatDate(
                                    status.xRTW,
                                    "MMM DD YYYY"
                                  )
                                  : "-"}
                              </td>

                              <td>
                                <img src={handSvg} alt="" height="17" width="17" />
                                <button
                                  className="case-btn"
                                  onClick={() =>
                                    history.push("/allcasedetails")
                                  }
                                >
                                  Case Details
                                </button>
                              </td>
                            </tr>
                            {status.otherData ? (
                              <>
                                <tr>
                                  <td colSpan="3">
                                    {/* Case Number */}
                                    {props.context.t("ACCOMODATION-Case-Number.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.CaseNumber
                                      ? status.otherData.CaseNumber
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("STD-PreviousHistoryCase.Text")}
                                  </td>
                                  <td colSpan="4">
                                    {Array.isArray(
                                      status.otherData.PreviousHistory
                                    ) &&
                                      status.otherData.PreviousHistory
                                        .length > 0 ? (
                                        <span>
                                          {
                                            status.otherData.PreviousHistory
                                              .length
                                          }
                                        &nbsp;other cases: &nbsp;
                                        </span>
                                      ) : "None"}
                                    {Array.isArray(
                                      status.otherData.PreviousHistory
                                    ) &&
                                      status.otherData.PreviousHistory.length > 1
                                      ? status.otherData.PreviousHistory.map(
                                        (history) => (
                                          <Fragment key={history.caseId}>
                                            <span>
                                              {history?.caseName}&nbsp;
                                              {history?.caseDate ? moment(history?.caseDate).format("MMM DD YYYY") : "-"}
                                              ,
                                            </span>
                                            <br />
                                          </Fragment>
                                        )
                                      )
                                      : null}
                                  </td>
                                </tr>

                                <tr>
                                  <td colSpan="3">{props.context.t("ACCOMODATION-Case-Type.CA")}</td>
                                  <td colSpan="4">
                                    {status.otherData.CaseType
                                      ? status.otherData.CaseType
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">{props.context.t("ACCOMODATION-Case-Manager.CA")}</td>
                                  <td colSpan="4">
                                    {status.otherData.CaseManager
                                      ? status.otherData.CaseManager
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("STD-NumberOfDaysOpen.Text")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData
                                      .NumberOfOpenDaysBussiness
                                      ? `${status.otherData.NumberOfOpenDaysBussiness} ${props.context.t("STD-BusinessDays.Text")}`
                                      : "-"}
                                    {status.otherData.NumberOfOpenDays
                                      ? `/${status.otherData.NumberOfOpenDays} ${props.context.t("STD-CalenderDays.Text")}`
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-Date-Employer.Statement.Received.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData
                                      .DateEmployerStatementReceived
                                      ? utilities.formatDate(
                                        status.otherData
                                          .DateEmployerStatementReceived,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-Date-Attending.Physician.Statement.Received.CA")}

                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.PhysicianStatement
                                      ? utilities.formatDate(
                                        status.otherData.PhysicianStatement,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">{props.context.t("ACCOMODATION-File-Status.Information.CA")}</td>
                                  <td colSpan="4">
                                    {Array.isArray(
                                      status.otherData.FileStatusInfo
                                    ) &&
                                      status.otherData.FileStatusInfo.length
                                      ? status.otherData.FileStatusInfo.map(
                                        (fileStatus) => (
                                          <Fragment
                                            key={fileStatus.statusName}
                                          >
                                            <span>
                                              &nbsp;
                                              {fileStatus?.statusName}
                                              &nbsp;-
                                              {fileStatus?.statusDate ? moment(fileStatus?.statusDate).format("MMM DD YYYY") : "-"}
                                              {/* &nbsp;/&nbsp;
                                                  {moment(
                                                    fileStatus?.toDate,
                                                    "MMM DD YYYY"
                                                  ).format("MMM DD YYYY")} */}
                                            </span>
                                            <br />
                                          </Fragment>
                                        )
                                      )
                                      : null}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-Dates-Medical.Updates.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.DateOfMedicalUpdates.replace("\r\n", ",") || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {/* Date In Reduction Of Benefits */}
                                    {props.context.t("CurrentActivity.Date In.Reduction.Of.Benefits.Text")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.DateOfReductioninBenefits || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-Date-became.Complex.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.DateCasebecame
                                      ? utilities.formatDate(
                                        status.otherData.DateCasebecame,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-AbsentFromWork.Text")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.FirstDayAbsent
                                      ? utilities.formatDate(
                                        status.otherData.FirstDayAbsent,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">{props.context.t("ACCOMODATION-Case-Status.Information.CA")}</td>
                                  <td colSpan="4">
                                    {Array.isArray(
                                      status.otherData.EIDates
                                    ) && status.otherData.EIDates.length
                                      ? status.otherData.EIDates.map(
                                        (eiDate) => (
                                          <Fragment key={eiDate.fromDate}>
                                            <span>
                                              &nbsp;{eiDate?.status}
                                              &nbsp;-
                                              {eiDate.fromDate ? moment(eiDate.fromDate).format("MMM DD YYYY") : "-"}
                                              &nbsp;-&nbsp;
                                              {eiDate.toDate ? moment(eiDate.toDate).format("MMM DD YYYY") : ""}
                                              <br />
                                              {"Hours:" + eiDate.hrs || eiDate.hrs}
                                            </span>
                                            <br />
                                            <br />
                                          </Fragment>
                                        )
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                {/* <tr>
                                    <td colSpan="3">
                                      Status From Date / To Date
                                    </td>
                                    <td colSpan="4">
                                      {Array.isArray(status.otherData.Status) &&
                                      status.otherData.Status.length
                                        ? status.otherData.Status.map(
                                            (status) => (
                                              <Fragment key={status.fromDate}>
                                                <span>
                                                  {status?.status}&nbsp;
                                                  {moment(
                                                    status?.fromDate,
                                                    "MMM DD YYYY"
                                                  ).format("MMM DD YYYY")}
                                                  /
                                                  {moment(
                                                    status?.toDate,
                                                    "MMM DD YYYY"
                                                  ).format("MMM DD YYYY")}
                                                </span>
                                                <br />
                                              </Fragment>
                                            )
                                          )
                                        : null}
                                    </td>
                                  </tr> */}
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-Restrictions-Limitations.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.RestrictionsLimitations && status.otherData.RestrictionsLimitations.split("\r\n").length > 0 ?
                                      <>
                                        <ul>
                                          {
                                            status.otherData.RestrictionsLimitations.split("\r\n").map((res) => (
                                              <li>{res}</li>
                                            ))
                                          }
                                        </ul>
                                      </> : "-"
                                    }

                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("STD-ERTWDate.Text")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.ExpectedRTWDate
                                      ? utilities.formatDate(
                                        status.otherData.ExpectedRTWDate,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {/* EI Dates */}
                                    {props.context.t("STD.EI.Dates")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.eiDatesText ? status.otherData.eiDatesText : null
                                    }
                                    {/* {Array.isArray(
                                      status.otherData.EIDates
                                    ) && status.otherData.EIDates.length
                                      ? status.otherData.EIDates.map(
                                        (eiDate) => (
                                          <Fragment key={eiDate.fromDate}>
                                            <span>
                                              &nbsp;{eiDate?.status}
                                              &nbsp;-
                                              {eiDate.fromDate ? moment(
                                                eiDate?.fromDate,
                                                "MMM DD YYYY"
                                              ).format("MMM DD YYYY") : ""}
                                              &nbsp;-&nbsp;
                                              {eiDate.toDate ? moment(
                                                eiDate?.toDate,
                                                "MMM DD YYYY"
                                              ).format("MMM DD YYYY") : ""}
                                            </span>
                                            <br />
                                          </Fragment>
                                        )
                                      )
                                      : null} */}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">{props.context.t("STD.STD.Expiry.Date")}</td>
                                  <td colSpan="4">
                                    {status.otherData.STDExpiryDate}
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td colSpan="1">Pay Reduction Date</td>
                                  <td colSpan="2">
                                    {status.otherData.payReductionDate}
                                  </td>
                                </tr> */}
                                <tr>
                                  <td colSpan="3">
                                    {/* Date Case Opened */}
                                    {props.context.t("ACCOMODATION-Date-Case.Opened.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.DateCaseOpened
                                      ? utilities.formatDate(
                                        status.otherData.DateCaseOpened,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">{props.context.t("ACCOMODATION-Date-Closed.CA")}</td>
                                  <td colSpan="4">
                                    {status.otherData.DateClosed
                                      ? utilities.formatDate(
                                        status.otherData.DateClosed,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="3">
                                    {props.context.t("ACCOMODATION-Last-Update.File.Status.CA")}
                                  </td>
                                  <td colSpan="4">
                                    {status.otherData.lastUpdateFileStatus ? status.otherData.lastUpdateFileStatus + "-" + " " + props.context.t("STD.Completed.on") + " " : null}
                                    {status.otherData.LastUpdate
                                      ? utilities.formatDate(
                                        status.otherData.LastUpdate,
                                        "MMM DD YYYY"
                                      )
                                      : "-"}
                                  </td>
                                </tr>

                                <tr>
                                  <td colSpan="3">{props.context.t("ACCOMODATION-Next-action.CA")}</td>
                                  <td colSpan="4">
                                    {status.otherData.NextAction
                                      ? status.otherData.NextAction
                                      : "-"}
                                  </td>
                                </tr>
                              </>
                            ) : null}
                          </Fragment>
                        ))
                        : null}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="table-footer">
                <span htmlFor="">{props.context.t("Attachment.TotalRows.Text")}: {props.totalRows}</span>

                <Pagination
                  currentPage={props.currentPage}
                  pageSize={props.pageSize}
                  totalRows={props.totalRows}
                  onClickPre={(pageNo) => {
                    onChange({
                      target: {
                        name: "currentPage",
                        value: pageNo,
                      },
                    });
                  }}
                  onClickNext={(pageNo) => {
                    onChange({
                      target: {
                        name: "currentPage",
                        value: pageNo,
                      },
                    });
                  }}
                  onClickPage={(pageNo) => {
                    onChange({
                      target: {
                        name: "currentPage",
                        value: pageNo,
                      },
                    });
                  }}
                ></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccomodationCaseStatustemplete;
